<template>
	<main class="w-100 flex-grow-1">
		<transition name="fade" mode="out-in">
			<router-view 
				:articles_data="articles_data"
				:props_search="props_search" />
		</transition>
	</main>
</template>

<script>
	export default {
		name: 'EmptyParentComponent',
		props: {
			props_search:		{
				type: 		String,
				default:	''
			},
			articles_data:		{
				type: 		Object,
				default:	() => {}
			}
		},
		data () {
			return {

			}
		}
	}
</script>

<style lang="css" scoped>
main {
	max-width: 100%;
}

@media (min-width: 1500px) {
	main {
		max-width: 1600px;
	}
}
</style>